export default {
  // xs: `768px`
  sm: `768px`,
  md: `992px`,
  lg: `1200px`,
}
